import { render, staticRenderFns } from "./areaChart.vue?vue&type=template&id=c5b99b2a&"
import script from "./areaChart.vue?vue&type=script&lang=js&"
export * from "./areaChart.vue?vue&type=script&lang=js&"
import style0 from "./areaChart.vue?vue&type=style&index=0&id=c5b99b2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports